import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class BranchesMetaModel extends FormMetaModel {
    constructor() {
        super('Add Branch', ROUTE_PATH.branchGrid, ROUTE_PATH.addBranches, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const department_name = new SmMetaInputModel(
            'department_name',
            'department_name',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Branch Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            60,
            1
        );

        const branchCategoryId= new SmMetaSelectModel(
            'branchCategoryId',
            'branchCategoryId',
            'ng-select',
            true,
            'col-12 col-md-6',
            1,
            2,
            'Branch Category',
            'number',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'branchCatName',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );
       



        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            department_name,
            branchCategoryId,


        }
    }
}